import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useParams } from "react-router-dom";
import { getCustomerBillingInvoiceDetail } from "../../../../services/customer";

import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useNotificationContext } from "../../../../contexts/NotificationContext";
import { copyTextToClipboard, logging } from "../../../../utils/functions";

import Loading from "../../../../components/Shared/Loading";

import PaymentMethodSelection from "../../../Home/RequiredVerificationStep/PaymentVerification/PaymentMethodSelection";

export default function AccountBillingInvoicePayment({ customer, close }: any) {
  const params = useParams();

  const { data: invoice } = getCustomerBillingInvoiceDetail(params?.invoice_id);

  const [paymentMethodSelected, setPaymentMethodSelected] = useState<any>(null)

  const { setNotification } = useNotificationContext()

  const ref = useMemo(() => `REF.${dayjs(new Date()).format("YYYYMMDDhhmmss")}.${invoice.invoice_id}`, [invoice])

  useEffect(() => {
    logging('AccountBillingInvoice ▶ CustomerBillingInvoiceDetail', invoice)
    logging('AccountBillingInvoice ▶ Props', customer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Stack direction="row" justifyContent="start" alignItems="center" sx={{ mt: -0.5 }}>
          <Typography fontSize={14} color={grey[700]}>{ref}</Typography>
          <IconButton aria-label="account-id" onClick={() => copyTextToClipboard(ref, () => setNotification({ message: `payment REF copied to clipboard`, severity: 'success', open: true }))}>
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Stack>
        <Typography fontWeight={700} fontSize={24}>Payment Overview</Typography>
        <Typography fontSize={14}>Kindly verify the details of the invoice, including the items and total amount, before you process the payment.</Typography>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Typography fontSize={14} color={grey[700]} sx={{ mb: 1 }}>Payment Amount</Typography>
        <Box component="hr" sx={{ my: 1 }} />
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Typography fontSize={13} color={grey[700]}>Sub Total</Typography>
          <Typography fontSize={14}>đ{invoice.invoice_subtotal?.toLocaleString()}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={13} color={grey[700]}>Tax @10%</Typography>
          <Typography fontSize={14}>đ{invoice.invoice_tax?.toLocaleString()}</Typography>
        </Stack>
        <Box component="hr" sx={{ my: 1 }} />
        <Typography fontSize={14} color={grey[700]}>Total</Typography>
        <Typography fontSize={20} fontWeight={600}>đ{invoice.invoice_total?.toLocaleString()}</Typography>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography fontSize={14} color={grey[700]} sx={{ mb: 1 }}>Payment Method</Typography>
        <React.Suspense fallback={<Loading />}>
          <PaymentMethodSelection customer={customer} defaultSelect={paymentMethodSelected} onChange={setPaymentMethodSelected} />
        </React.Suspense>
      </Box>
      <Box>
        <Button fullWidth disabled={paymentMethodSelected === null} variant="contained" sx={{ mt: 4, mb: 1 }}>
          <Typography fontSize={14} fontWeight={700} sx={{ textTransform: 'capitalize', mr: 1 }}>Make Payment</Typography>
        </Button>
        <Button fullWidth onClick={close} sx={{ border: `1px solid ${grey[900]}`, bgcolor: 'transparent ! important' }}>
          <Typography fontSize={14} sx={{ color: grey[900] }}>Cancel</Typography>
        </Button>
      </Box>
    </Box>
  )
}